import { createRouter, createWebHistory } from "vue-router";
// import VueRouteMiddleware from "vue-route-middleware";
// import authMiddleware from "@/middleware/auth";

let environment = null;
if (typeof process.env.VUE_APP_DEPLOYMENT_ENVIRONMENT !== "undefined") {
  const tempEnvironment = process.env.VUE_APP_DEPLOYMENT_ENVIRONMENT.trim();
  if (["local", "dev", "uat", "prod"].includes(tempEnvironment)) {
    environment = tempEnvironment;
  }
}

const routes = [
  {
    path: "/validation",
    component: () => import("@/views/pages/Validation.vue"),
    meta: {
      title: "Vertex SOC",
    },
  },
  {
    path: "/",
    component: () => import("@/views/layouts/Dashboard.vue"),
    meta: {
      // middleware: [authMiddleware],
      title: "Vertex SOC",
    },
    children: [
      {
        path: "",
        name: "dashboard",
        component: () => import("@/views/pages/Dashboard.vue"),
      },
      {
        path: "downloads",
        name: "downloads",
        component: () => import("@/views/pages/Downloads.vue"),
      },
      {
        path: "malicious-ips-list",
        name: "maliciousIpsList",
        component: () =>
          import("@/views/pages/organisations/MaliciousIpsList.vue"),
      },
      {
        path: "org-ips-locations",
        name: "ipsAndLocations",
        component: () =>
          import("@/views/pages/organisations/IpsAndLocations.vue"),
      },
      {
        path: "isp-server-hostings",
        name: "ispServerHostings",
        component: () =>
          import("@/views/pages/organisations/IspServerHostings.vue"),
      },
      {
        path: "alerts",
        name: "alerts",
        component: () => import("@/views/pages/organisations/Alerts.vue"),
      },
      {
        path: "dns-lookup",
        name: "dnsLookup",
        component: () => import("@/views/pages/DnsLookup.vue"),
      },
      {
        path: "logs-ingested",
        name: "logsIngested",
        component: () => import("@/views/pages/LogsIngested.vue"),
      },
      // {
      //   path: "successful-logins",
      //   name: "successfulLogins",
      //   component: () => import("@/views/pages/FailedLogins.vue"),
      // },
      // {
      //   path: "failed-logins",
      //   name: "failedLogins",
      //   component: () => import("@/views/pages/FailedLogins.vue"),
      // },
      {
        path: "reports",
        name: "reports",
        component: () => import("@/views/pages/reports/Reports.vue"),
      },
      {
        path: "reports/application-log-events/:eventSlug?",
        name: "reportsApplicationLogEvents",
        component: () =>
          import("@/views/pages/reports/ApplicationLogEvents.vue"),
      },
      {
        path: "reports/dmarc",
        name: "reportsDmarc",
        component: () => import("@/views/pages/reports/Dmarc.vue"),
      },
      {
        path: "reports/azure",
        name: "reportsAzure",
        component: () => import("@/views/pages/reports/Azure.vue"),
      },
      {
        path: "reports/microsoft-365",
        name: "reportsMicrosoft365",
        component: () => import("@/views/pages/reports/Microsoft365.vue"),
      },
      {
        path: "reports/suspicious-or-malicious-sign-in-alerts",
        name: "suspiciousOrMaliciousSigninAlerts",
        component: () =>
          import("@/views/pages/reports/SuspiciousOrMaliciousSigninAlerts.vue"),
      },
      {
        path: ":catchAll(.*)",
        name: "pageNotFound",
        component: () => import("@/views/pages/NotFound.vue"),
      },
    ],
  },
  {
    path: "/log-sources",
    component: () => import("@/views/layouts/LogSources.vue"),
    meta: {
      // middleware: [authMiddleware],
      title: "Vertex SOC",
    },
    children: [
      {
        path: "",
        name: "logSource",
        component: () => import("@/views/pages/log-sources/LogSources.vue"),
      },
      {
        path: "add",
        name: "addLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep1.vue"),
      },
      {
        path: "add/syslog",
        name: "addSyslogLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Syslog.vue"),
      },
      {
        path: "add/aws",
        name: "addAwsLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Aws.vue"),
      },
      {
        path: "add/sftp",
        name: "addSftpLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Sftp.vue"),
      },
      {
        path: "add/azuread",
        name: "addAzureadLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Azuread.vue"),
      },
      {
        path: "add/dmarc",
        name: "addDmarcLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Dmarc.vue"),
      },
      {
        path: "add/auth0",
        name: "addAuth0LogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Auth0.vue"),
      },
      {
        path: "add/google-workspace",
        name: "addGoogleWorkspaceLogSource",
        component: () =>
          import(
            "@/views/pages/log-sources/AddLogSourceStep2GoogleWorkspace.vue"
          ),
      },
      {
        path: "add/jumpcloud",
        name: "addJumpcloudLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Jumpcloud.vue"),
      },
      {
        path: ":id/log-history",
        name: "logHistory",
        component: () => import("@/views/pages/log-sources/LogHistory.vue"),
      },
      {
        path: ":id/syslog",
        name: "editSyslogLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Syslog.vue"),
      },
      {
        path: ":id/aws",
        name: "editAwsLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Aws.vue"),
      },
      {
        path: ":id/sftp",
        name: "editSftpLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Sftp.vue"),
      },
      {
        path: ":id/azuread",
        name: "editAzureadLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Azuread.vue"),
      },
      {
        path: ":id/dmarc",
        name: "editDmarcLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Dmarc.vue"),
      },
      {
        path: ":id/auth0",
        name: "editAuth0LogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Auth0.vue"),
      },
      {
        path: ":id/google-workspace",
        name: "editGoogleWorkspaceLogSource",
        component: () =>
          import(
            "@/views/pages/log-sources/AddLogSourceStep2GoogleWorkspace.vue"
          ),
      },
      {
        path: ":id/jumpcloud",
        name: "editJumpcloudLogSource",
        component: () =>
          import("@/views/pages/log-sources/AddLogSourceStep2Jumpcloud.vue"),
      },
    ],
  },
];

let children = [
  {
    path: "configs",
    name: "configs",
    component: () => import("../views/test/Configs.vue"),
  },
  {
    path: "logs/:logSourceType?",
    name: "logs",
    component: () => import("../views/test/Logs.vue"),
  },
  {
    path: "platforms",
    name: "platforms",
    component: () => import("../views/test/Platforms.vue"),
  },
  {
    path: "cache-files/:logSourceId?",
    name: "cacheFiles",
    component: () => import("../views/test/TestCacheFiles.vue"),
  },
  {
    path: "ip-geolocation",
    name: "ipGeolocation",
    component: () => import("../views/test/IpGeolocation.vue"),
  },
  {
    path: "cache/:id",
    name: "testCache",
    component: () => import("../views/test/Cache.vue"),
  },
  {
    path: "add-log-sources-by-json",
    name: "testAddLogSourcesByJson",
    component: () => import("../views/test/AddLogSourcesByJson.vue"),
  },
  {
    path: "core",
    name: "core",
    component: () => import("../views/test/Core.vue"),
  },

  ...(environment !== null && ["local", "dev"].includes(environment)
    ? [
        {
          path: "aws-log-source-bucket/:id",
          name: "testAwsLogSourceBucket",
          component: () => import("../views/test/AwsLogSourceBucket.vue"),
        },
        {
          path: "aws-log-source-files/:id/:mode?",
          name: "testAwsLogSourceFiles",
          component: () => import("../views/test/AwsLogSourceFiles.vue"),
        },
        {
          path: "sftp-log-source-folder/:id",
          name: "testSftpLogSourceFolder",
          component: () => import("../views/test/SftpLogSourceFolder.vue"),
        },
        {
          path: "sftp-log-source-files/:id/:mode?",
          name: "testASftpLogSourceFiles",
          component: () => import("../views/test/SftpLogSourceFiles.vue"),
        },
      ]
    : []),
];

routes.push({
  path: "/test",
  component: () => import("@/views/layouts/Dashboard.vue"),
  meta: {
    // middleware: [authMiddleware],
    title: "Vertex SOC",
  },
  children,
});

if (typeof process.env.VUE_APP_DEPLOYMENT_ENVIRONMENT !== "undefined") {
  const env = process.env.VUE_APP_DEPLOYMENT_ENVIRONMENT.trim();
  if (["local", "dev", "uat"].includes(env)) {
    let children = [
      {
        path: "configs",
        name: "testConfigs2",
        component: () => import("../views/test-2/Configs.vue"),
      },
      {
        path: "connections",
        name: "testConnections2",
        component: () => import("../views/test-2/Connections.vue"),
      },
      {
        path: "ip-geolocation",
        name: "testIpGeolocation2",
        component: () => import("../views/test-2/IpGeolocation.vue"),
      },
      {
        path: "logs/:type?",
        name: "testLogs2",
        component: () => import("../views/test-2/Logs.vue"),
      },
      {
        path: "platforms",
        name: "testPlatforms2",
        component: () => import("../views/test-2/Platforms.vue"),
      },
      {
        path: "mariadb-tables/:tableName?",
        name: "testMariadbTables2",
        component: () => import("../views/test-2/MariadbTables.vue"),
      },
      {
        path: "srslog",
        name: "testSrslog2",
        component: () => import("../views/test-2/SrsLog.vue"),
      },
    ];

    routes.push({
      path: "/test-2",
      component: () => import("@/views/layouts/Test2.vue"),
      meta: {
        title: "Vertex SOC",
      },
      children,
    });
  }
}

// https://router.vuejs.org/guide/essentials/history-mode.html

// https://next.router.vuejs.org/guide/essentials/history-mode.html#hash-mode

const router = createRouter({
  // mode: "history",
  history: createWebHistory(),
  routes,
});

// https://stackoverflow.com/questions/49258849/could-not-find-a-declaration-file-for-module-vue-xxx

// router.beforeEach(VueRouteMiddleware({ authMiddleware }));

// https://stackoverflow.com/questions/51639850/how-to-change-page-titles-when-using-vue-router

router.beforeEach((to, _, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
